"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useKeyMap = exports.getFocusHandler = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useKeyMap = function useKeyMap(
/**
 * The Key that was pressed.
 */
event,
/**
 * keyMap: Should be an object looking like:
 * {
 *  [Key.ArrowUp]: values => {
 *      what you wanna do
 *      you can use values.next, values.prev [...] to get according values from the value list/map you passed via the values prop
 *  }
 * }
 */
keyMap, focusHandler) {
  if (Object.keys(keyMap).includes(event.key)) {
    var keyHandler = keyMap[event.key];
    if (keyHandler.fn) {
      var keyHandlerObj = keyHandler;
      if ((!event.shiftKey || keyHandlerObj.allowShift) && (!event.ctrlKey || keyHandlerObj.allowCtrl) && (!event.altKey || keyHandlerObj.allowAlt)) {
        keyHandlerObj.fn(focusHandler);
        if (!keyHandlerObj.noPreventDefault) {
          event.preventDefault();
        }
      }
    } else {
      var keyHandlerFn = keyHandler;
      if (!event.shiftKey && !event.ctrlKey && !event.altKey) {
        keyHandlerFn(focusHandler);
        event.preventDefault();
      }
    }
  }
};
exports.useKeyMap = useKeyMap;
var getFocusHandler = function getFocusHandler(
/**
 * Pass an array of values (example: Accordion, SelectDropdown) or a map (array of array) of values (example: Header).
 * You can then get next/prev/above/below/first/last values inside the functions you provide for each key via keyMap prop.
 */
values,
/**
 * Pass the currently active value - this has to be an element within values.
 */
activeValue) {
  if (values && activeValue) {
    var is2D = Array.isArray(values[0]);
    var vals1D = values;
    var vals2D = values;
    var getActiveCoords = function getActiveCoords() {
      if (is2D) {
        var y = vals2D.findIndex(function (val) {
          return val.includes(activeValue);
        });
        return [vals2D[y].findIndex(function (val) {
          return val === activeValue;
        }), y];
      }
      return [vals1D.findIndex(function (val) {
        return val === activeValue;
      }), 0];
    };
    return !is2D ? {
      curr: function curr() {
        return activeValue;
      },
      first: function first() {
        return vals1D[0];
      },
      last: function last() {
        return vals1D.slice(-1)[0];
      },
      next: function next(cb) {
        var _getActiveCoords = getActiveCoords(),
          _getActiveCoords2 = _slicedToArray(_getActiveCoords, 1),
          i = _getActiveCoords2[0];
        var isLast = i === vals1D.length - 1;
        var newIndex = isLast ? 0 : i + 1;
        return isLast && cb ? cb() : vals1D[newIndex];
      },
      prev: function prev(cb) {
        var _getActiveCoords3 = getActiveCoords(),
          _getActiveCoords4 = _slicedToArray(_getActiveCoords3, 1),
          i = _getActiveCoords4[0];
        var isFirst = i === 0;
        var newIndex = isFirst ? vals1D.length - 1 : i - 1;
        return isFirst && cb ? cb() : vals1D[newIndex];
      }
    } : {
      curr: function curr() {
        return activeValue;
      },
      first: function first() {
        return vals2D[0].find(function (vals) {
          return vals;
        });
      },
      last: function last() {
        var lastY = vals2D.length - 1;
        var lastX = vals2D[lastY].length - 1;
        return vals2D[lastY][lastX];
      },
      next: function next(cb) {
        var _getActiveCoords5 = getActiveCoords(),
          _getActiveCoords6 = _slicedToArray(_getActiveCoords5, 2),
          x = _getActiveCoords6[0],
          y = _getActiveCoords6[1];
        var lineBelow = vals2D[y + 1];
        if (x + 1 < vals2D[y].length) {
          return vals2D[y][x + 1];
        }
        if (x + 1 >= vals2D[y].length - 1 && lineBelow && lineBelow[0]) {
          return lineBelow[0];
        }
        cb();
        return;
      },
      prev: function prev(cb) {
        var _getActiveCoords7 = getActiveCoords(),
          _getActiveCoords8 = _slicedToArray(_getActiveCoords7, 2),
          x = _getActiveCoords8[0],
          y = _getActiveCoords8[1];
        var lineAbove = vals2D[y - 1];
        if (x - 1 >= 0 && vals2D[y][x - 1]) {
          return vals2D[y][x - 1];
        }
        if (x - 1 < 0 && lineAbove && lineAbove[lineAbove.length - 1]) {
          return lineAbove[lineAbove.length - 1];
        }
        cb();
        return;
      },
      above: function above(cb) {
        var _getActiveCoords9 = getActiveCoords(),
          _getActiveCoords10 = _slicedToArray(_getActiveCoords9, 2),
          x = _getActiveCoords10[0],
          y = _getActiveCoords10[1];
        var lineAbove = vals2D[y - 1];
        if (lineAbove && lineAbove[x]) {
          return lineAbove[x];
        }
        cb();
        return;
      },
      below: function below(cb) {
        var _getActiveCoords11 = getActiveCoords(),
          _getActiveCoords12 = _slicedToArray(_getActiveCoords11, 2),
          x = _getActiveCoords12[0],
          y = _getActiveCoords12[1];
        var lineBelow = vals2D[y + 1];
        if (lineBelow && lineBelow[x]) {
          return lineBelow[x];
        }
        cb();
        return;
      }
    };
  }
};
exports.getFocusHandler = getFocusHandler;